import PropTypes from 'prop-types';

export default {
  lat: PropTypes.number,
  lng: PropTypes.number,
  name: PropTypes.string,
  placeId: PropTypes.string
};
